import PropTypes from "prop-types";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../../redux/actions/cartActions";
import { addToWishlist } from "../../../redux/actions/wishlistActions";
import { addToCompare } from "../../../redux/actions/compareActions";
import ProductTeaser from "./ProductTeaser";
import ProductTeaserWrap from "../productList/ProductTeaserWrap";

// A product card (grid teaser, or list row for layout "list") wired to the currency, cart,
// wishlist and compare state, so callers only pass the product. `itemId` is the id the product
// has in those lists; it defaults to the product's own id.
const ConnectedProduct = ({ product, layout, itemId = product.id }) => {
    const dispatch = useDispatch();
    const currency = useSelector((state) => state.currencyData);
    const cartItem = useSelector((state) => state.cartData.find((item) => item.id === itemId));
    const wishlistItem = useSelector((state) => state.wishlistData.find((item) => item.id === itemId));
    const compareItem = useSelector((state) => state.compareData.find((item) => item.id === itemId));

    const Item = layout === "list" ? ProductTeaserWrap : ProductTeaser;

    return (
        <Item
            product={product}
            currency={currency}
            addToCart={(item, quantityCount, selectedProductColor, selectedProductSize) =>
                dispatch(addToCart(item, quantityCount, selectedProductColor, selectedProductSize))
            }
            addToWishlist={(item) => dispatch(addToWishlist(item))}
            addToCompare={(item) => dispatch(addToCompare(item))}
            cartItem={cartItem}
            wishlistItem={wishlistItem}
            compareItem={compareItem}
        />
    );
};

ConnectedProduct.propTypes = {
    itemId: PropTypes.string,
    layout: PropTypes.string,
    product: PropTypes.object.isRequired,
};

export default ConnectedProduct;
